export const StaticFilters = {
  HAS_INVENTORY: 'hasInventory',
  IS_APPROVED: 'isApproved',
  IS_RETAILER_APPROVED: 'isRetailerApproved',
  ASSIGNED_TO_RETAILERS: 'assignedToRetailers',
  VARIANTS_HAS_INVENTORY: 'variantHasInventory',
  VARIANT_IS_APPROVED: 'variantIsApproved',
  APPROVED_STATUS: 'approvedStatus',
  ACTIVE_PRODUCTS: 'activeProducts',
  CUSTOM_BUFFERS: 'customBuffers',
};

export const StaticFilterKeys = {
  [StaticFilters.HAS_INVENTORY]: 'Has Inventory?',
  [StaticFilters.IS_APPROVED]: 'Is Approved?',
  [StaticFilters.IS_RETAILER_APPROVED]: 'Is Approved?',
  [StaticFilters.ASSIGNED_TO_RETAILERS]: 'Approved to Channels?',
  [StaticFilters.VARIANTS_HAS_INVENTORY]: 'Has Inventory?',
  [StaticFilters.VARIANT_IS_APPROVED]: 'Approved to Channels?',
  [StaticFilters.APPROVED_STATUS]: 'Approved Status',
  [StaticFilters.ACTIVE_PRODUCTS]: 'Active/Archived',
  [StaticFilters.CUSTOM_BUFFERS]: 'Buffers',
};
